import { GetStaticPaths, GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'

import { AppGatePage } from '../../components/app-gate/AppGatePage'

/**
 * /challenges — feature Desafiar; /challenges/requests/:uuid — convite de
 * desafio (deep link compartilhado pelo app; pessoal, não indexado).
 */
export default function Challenges({ isRequest }: { isRequest: boolean }) {
  if (isRequest) {
    return <AppGatePage gateKey="challengeInvite" ticks={3} noindex />
  }
  return <AppGatePage gateKey="challenges" ticks={3} />
}

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [{ params: { slug: [] } }],
  fallback: 'blocking',
})

export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
  const slug = (params?.slug as string[]) || []
  const isRequest = slug[0] === 'requests' && slug.length >= 2

  return {
    props: {
      isRequest,
      ...(await serverSideTranslations(locale || 'pt', [
        'common',
        'gates',
        'landing',
      ])),
    },
  }
}
